import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { IApiParams } from '../../interface/IApiParams';
import { getApiVersion } from '../../utils/utils';
import { getApi } from '../getApi';

export const apiGetServices = async () => {
  const apiVersion = getApiVersion();
  const params: IApiParams = {
    url: `/service/getServices${apiVersion}.php`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
